import { DataGrid } from "@mui/x-data-grid";
import { useSearch } from "../context/SearchContext";
import { useMemo } from "react";

const SearchableDataGrid = ({ rows, columns, ...props }) => {
  const { searchText } = useSearch();

  const filteredRows = useMemo(() => {
    if (!searchText) return rows;

    return rows.filter((row) =>
      Object.values(row)
        .join(" ")
        .toLowerCase()
        .includes(searchText.toLowerCase())
    );
  }, [rows, searchText]);

  return (
    <DataGrid
      rows={filteredRows}
      columns={columns}
      {...props}
    />
  );
};

export default SearchableDataGrid;
